import { Injectable } from '@angular/core';
import { FiBackendService } from '@fi-shared/fi-backend/fi-backend.service';
import { ILightWeightObjectCollection } from '@fi-shared/models';
import { IChecklistReportCheckpointsData, IChecklistReportData, IChecklistReportSelection } from './checklist-report';
import { IItemsListDataFetchResult, IItemsListParameterBase } from '@fi-shared/fi-items-list/fi-items-list';

@Injectable()
export class ChecklistReportService {
    constructor(private fiBackend: FiBackendService) {}

    getCheckListReportsListData(parameter: IItemsListParameterBase) {
        return this.fiBackend.fetchDataPost<IItemsListDataFetchResult<any>>(
            'CheckListReports/CheckListReports/GetCheckListReportsListData',
            parameter,
        );
    }

    getCheckListReportsCount(parameterApiModel, reqConfig?) {
        return this.fiBackend.fetchDataPost<number>(
            'CheckListReports/CheckListReports/GetCheckListReportsCount',
            parameterApiModel,
            reqConfig,
        );
    }

    getCheckListReports(parameterApiModel, reqConfig?) {
        return this.fiBackend.fetchDataPost<any[]>(
            'CheckListReports/CheckListReports/GetCheckListReports',
            parameterApiModel,
            reqConfig,
        );
    }

    GetLightWeightObjectsForLocalSearch(parameterApiModel, reqConfig?) {
        return this.fiBackend.fetchDataPost<ILightWeightObjectCollection>(
            'CheckListReports/CheckListReports/GetLightWeightObjectsForLocalSearch',
            parameterApiModel,
            reqConfig,
        );
    }

    getCheckListReportSelections(checkListId: number) {
        return this.fiBackend.fetchData(
            'CheckListReports/CheckListReports/GetCheckListReportSelections/' + checkListId,
        );
    }

    saveCheckListReportSelection(checkListId: number, checkListReportSelection: IChecklistReportSelection) {
        return this.fiBackend.fetchDataPost<number>(
            'CheckListReports/CheckListReports/SaveCheckListReportSelection/' + checkListId,
            checkListReportSelection,
        );
    }

    updateCheckListReportSelectionIsDefault(checkListReportSelectionId, isDefault) {
        return this.fiBackend.fetchDataPost<boolean>(
            'CheckListReports/CheckListReports/UpdateCheckListReportSelectionIsDefault/' + checkListReportSelectionId,
            isDefault,
        );
    }

    deleteCheckListReportSelection(checkListReportSelectionId: number) {
        return this.fiBackend.fetchDataPost(
            'CheckListReports/CheckListReports/DeleteCheckListReportSelection/' + checkListReportSelectionId,
        );
    }

    getBusinessUnitsForCheckListReports(checkListId: number) {
        return this.fiBackend.fetchData(
            'CheckListReports/CheckListReports/GetBusinessUnitsForCheckListReports/' + checkListId,
        );
    }

    getBusinessAreasForCheckListReports(checkListId: number) {
        return this.fiBackend.fetchData(
            'CheckListReports/CheckListReports/GetBusinessAreasForCheckListReports/' + checkListId,
        );
    }

    getCheckListReportNames() {
        return this.fiBackend.fetchData('CheckListReports/CheckListReports/GetCheckListReportNames');
    }

    getCheckListReport(id) {
        return this.fiBackend.fetchData('CheckListReports/CheckListReports/GetCheckListReport/' + id);
    }

    GetCheckListReportDetails(checklistId, startDate, endDate, businessUnitIds) {
        return this.fiBackend.fetchDataPost<IChecklistReportData>(
            'CheckListReports/CheckListReports/GetCheckListReportDetails',
            {
                CheckListId: checklistId,
                StartDate: startDate,
                EndDate: endDate,
                BusinessUnitIds: businessUnitIds,
            },
        );
    }

    GetCheckListUnitReportDetails(checklistId, startDate, endDate, businessUnitId, status) {
        return this.fiBackend.fetchDataPost<IChecklistReportCheckpointsData>(
            'CheckListReports/CheckListReports/GetCheckListUnitReportDetails',
            {
                CheckListId: checklistId,
                StartDate: startDate,
                EndDate: endDate,
                BusinessUnitId: businessUnitId,
                Status: status,
            },
        );
    }
}
